// mockApi.js

// Simulating a delay for API calls
const simulateApiDelay = (data) => {
    return new Promise((resolve) => {
      setTimeout(() => resolve(data), 1000); // Simulate 1 second delay
    });
  };
  
  // Mock data for users and roles
  let mockUsers = [
    { id: 1, name: 'Devansh Jain', email: 'dev@gmail.com', role: 'Admin', status: 'Active' },
    { id: 2, name: 'Test User', email: 'test@gmail.com', role: 'Editor', status: 'Inactive' },
  ];
  
  let mockRoles = [
    { id: 1, name: 'Admin', description: 'Full access to the system' },
    { id: 2, name: 'Editor', description: 'Can edit content' },
    { id: 3, name: 'Viewer', description: 'Can read content' },
  ];
  
  // ----------------- Users CRUD Operations -----------------
  
  export const getUsers = () => simulateApiDelay(mockUsers);
  
  export const addUser = (user) => {
    const newUser = { ...user, id: mockUsers.length + 1 }; // Generate new user ID
    mockUsers.push(newUser);
    return simulateApiDelay(newUser);
  };
  
  export const editUser = (id, updatedUser) => {
    const index = mockUsers.findIndex((user) => user.id === id);
    if (index !== -1) {
      mockUsers[index] = { ...mockUsers[index], ...updatedUser };
      return simulateApiDelay(mockUsers[index]);
    }
    return simulateApiDelay(null); // Return null if user not found
  };
  
  export const deleteUser = (id) => {
    mockUsers = mockUsers.filter((user) => user.id !== id);
    return simulateApiDelay(id);
  };
  
  // ----------------- Roles CRUD Operations -----------------
  
  export const getRoles = () => simulateApiDelay(mockRoles);
  
  export const addRole = (role) => {
    const newRole = { ...role, id: mockRoles.length + 1 }; // Generate new role ID
    mockRoles.push(newRole);
    return simulateApiDelay(newRole);
  };
  
  export const editRole = (id, updatedRole) => {
    const index = mockRoles.findIndex((role) => role.id === id);
    if (index !== -1) {
      mockRoles[index] = { ...mockRoles[index], ...updatedRole };
      return simulateApiDelay(mockRoles[index]);
    }
    return simulateApiDelay(null); // Return null if role not found
  };
  
  export const deleteRole = (id) => {
    mockRoles = mockRoles.filter((role) => role.id !== id);
    return simulateApiDelay(id);
  };
  